const zeropad = function(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

const throttle = function(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date(),
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}

const debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}


const isElement = function(el) {
	return el && el.nodeType === Node.ELEMENT_NODE
}

const addClass = function(el, className) {
	if (!isElement(el)) {
		return
	}
	if (el.className) {
		let classes = el.className.split(' ')
		if (classes.indexOf(className) < 0) {
			classes.push(className)
			el.className = classes.join(' ')
		}
	} else {
		el.className = className
	}
}

const removeClass = function(el, className) {
	if (!isElement(el)) {
		return
	}
	if (el.className) {
		let classes = el.className.split(' ')
		let newClasses = []
		for (let i = 0, l = classes.length; i < l; i++) {
			if (classes[i] !== className) {
				newClasses.push(classes[i])
			}
		}
		el.className = newClasses.join(' ')
	}
}

export default {zeropad, throttle, debounce, addClass, removeClass, isElement }
